import { render, staticRenderFns } from "./NewsCategoryAdmin.vue?vue&type=template&id=60698e20&scoped=true"
import script from "./NewsCategoryAdmin.vue?vue&type=script&lang=js"
export * from "./NewsCategoryAdmin.vue?vue&type=script&lang=js"
import style0 from "./NewsCategoryAdmin.vue?vue&type=style&index=0&id=60698e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60698e20",
  null
  
)

export default component.exports